import { Link } from "react-router-dom"
import { ArrowRight, Users, Building2, Shield, Award, Heart, Sparkles } from "lucide-react"
import ImageSlider from "../components/ImageSlider"

export default function HomePage() {
  const features = [
    {
      icon: Users,
      title: "सामान्य आरोग्य तपासणी",
      description: "रक्तदाब, साखर, कोलेस्ट्रॉल, हृदयाचे परीक्षण इत्यादी.",
      link: "https://vervecollege.edu/wp-content/uploads/2025/08/Medical-advice-vs-medical-information-1.jpg",
    },
    {
      icon: Heart,
      title: "वैद्यकीय सल्ला आणि मार्गदर्शन",
      description: "डाएबिटीज, हृदय रोग, स्नायू दुखणे, अस्थिमा यासारख्या आजारांसाठी सल्ला.",
      link: "https://vervecollege.edu/wp-content/uploads/2025/08/Medical-advice-vs-medical-information-1.jpg",
    },
    {
      icon: Shield,
      title: "टीकाकरण / लसीकरण सेवा",
      description: "मुलं, वृद्ध नागरिक, आणि महिलांसाठी लसीकरण योजना.",
      link: "https://vervecollege.edu/wp-content/uploads/2025/08/Medical-advice-vs-medical-information-1.jpg",
    },
    {
      icon: Shield,
      title: "आहार आणि पोषण सल्ला",
      description: "संतुलित आहार, वजन नियंत्रण, पोषण सुधारणा.",
      link: "https://vervecollege.edu/wp-content/uploads/2025/08/Medical-advice-vs-medical-information-1.jpg",
    },
    {
      icon: Sparkles,
      title: "मानसिक आरोग्य सेवा",
      description: "तणाव व्यवस्थापन, मानसिक स्वास्थ्य कार्यशाळा, सल्ला.",
      link: "/mental-health",
    },
    {
      icon: Building2,
      title: "विशेष आरोग्य मोहीम",
      description: "हृदय दिवस, डायबिटीज सप्ताह, महिलांचा आरोग्य दिन यासारख्या विशेष मोहीम.",
      link: "/special-campaigns",
    },
  ]

  const successStories = [
    {
      name: "प्रिया शर्मा",
      business: "डायबेटीस व्यवस्थापन",
      district: "पुणे",
      story: "आपले आरोग्य आपल्या हातीच्या मदतीने मी माझ्या डायबेटीस व्यवस्थापनावर लक्ष ठेवायला सुरुवात केली आणि आता माझे आरोग्य सुधारले आहे.",
    },
    {
      name: "सुनीता पाटील",
      business: "हृदय आरोग्य सुधारणा",
      district: "मुंबई",
      story: "आपले आरोग्य आपल्या हातीच्या मार्गदर्शनाखाली हृदयाच्या आजारांपासून स्वतःचे रक्षण करणे शिकले आणि मी माझ्या कुटुंबाचेही आरोग्य सुधारले.",
    },
    {
      name: "मीरा देशमुख",
      business: "स्नायू दुखणे व्यवस्थापन",
      district: "नाशिक",
      story: "आपले आरोग्य आपल्या हातीच्या मदतीने मी स्नायू दुखणे कमी करण्यासाठी योग्य व्यायाम आणि आहाराचे पालन केले आणि आता मी निरोगी जीवन जगते.",
    },
  ]

  return (
    <main className="min-h-screen">
      {/* Hero Section */}

      {/* Image Slider Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">आमचे कार्य</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              आरोग्य संवर्धनाच्या दिशेने आमच्या संस्थेच्या विविध उपक्रमांची झलक
            </p>
          </div>
          <ImageSlider />
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">आमच्या सेवा</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">महिलांच्या सक्षमीकरणासाठी आम्ही विविध सेवा पुरवतो</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {features.map((feature, index) => {
              const Icon = feature.icon
              return (
                <div
                  key={index}
                  className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 group animate-fade-in-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="w-16 h-16 gradient-purple rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                  <p className="text-gray-600 mb-6">{feature.description}</p>
                  <Link
                    to={feature.link}
                    className="inline-flex items-center text-purple-600 font-semibold hover:text-purple-700 group"
                  >
                    अधिक जाणा
                    <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">यशोगाथा</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">आमच्या सदस्यांच्या प्रेरणादायक कहाण्या</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {successStories.map((story, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 gradient-teal rounded-full flex items-center justify-center">
                    <Award className="w-6 h-6 text-white" />
                  </div>
                  <div className="ml-4">
                    <h3 className="font-bold text-gray-900">{story.name}</h3>
                    <p className="text-sm text-gray-600">
                      {story.business} • {story.district}
                    </p>
                  </div>
                </div>
                <p className="text-gray-700 italic">"{story.story}"</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 gradient-purple text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <Heart className="w-16 h-16 mx-auto mb-6 animate-float" />
          <h2 className="text-3xl md:text-4xl font-bold mb-6">आमच्यासोबत जुडा आणि सशक्त बना</h2>
          <p className="text-xl mb-8 text-white/90">
            महिला सक्षमीकरणाच्या या प्रवासात सामील व्हा आणि आपल्या स्वप्नांना साकार करा
          </p>
          <Link
            to="/register"
            className="inline-flex items-center px-8 py-4 bg-white text-purple-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors duration-200 group"
          >
            आज सामील व्हा
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </section>
    </main>
  )
}
